import { Image, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

export const NoAccess: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <VStack p="12" spacing="4" textAlign="center">
      <Image
        src="https://tradewing-public.s3.us-east-2.amazonaws.com/tradewing-logo.png"
        alt="Tradewing"
        width="50px"
        height="50px"
      />
      <Text textStyle="xlBodyStrong">Page Not Found</Text>
      <Text>{message || "This group has been hidden by your administrator and can't be accessed. For questions or concerns, contact your administrator."}</Text>
    </VStack>
  );
};